import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'

// 分页组件封装
import Pagination from '@/components/Pagination'
// 自定义表格工具扩展
import RightToolbar from '@/components/RightToolbar'

import 'normalize.css/normalize.css'
import '@/assets/styles/index.scss'
import '@/assets/icons' // icon

Vue.config.productionTip = false

// 全局挂载组件
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
